module.exports = __webpack_public_path__ + "assets/chili-piper.438f05b4.svg";